import React, { useEffect, useState } from "react";
import styles from "./ConfirmedBookings.module.css";
import { useHistory, useLocation } from "react-router";
import axios from "../../axios.js";
import styles2 from "./PendingBookings.module.css";

const ConfirmBookings = () => {
  const [confirmedShoot, setConfirmedShoot] = useState([]);
  const [orderId, setOrderId] = useState();
  const location = useLocation();

  const getOrderList = async () => {
    try {
      const res = await axios.get("book/request/specificCustomers");
      setOrderId(res.data[0]._id);
      setConfirmedShoot(res.data[0].requests);
      console.log(res.data[0].requests);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getOrderList();
  }, [location]);

  return (
    <div className={styles["NewDashboard-photoshootCard"]}>
      {confirmedShoot && confirmedShoot.length > 0 ? (
        confirmedShoot.map((request, id) => {
          return (
            request.status === "confirmed" && (
              <div className={styles["pending-booking__container"]} key={id}>
                <h6>{request.orderData.date}</h6>
                <div className={styles["pending-booking__inner"]}>
                  <h3>{request.orderData.city}</h3>
                  <p>{request.orderData.service}</p>
                  <p>
                    {request.orderData.package} (₹
                    {request.orderData.package_price})
                  </p>
                </div>
                <h6>
                  Status : <span>{request.status}</span>
                </h6>
              </div>
            )
          );
        })
      ) : (
        <h3 className={styles["no_confirm_booking_heading"]}>
          No confirmed bookings to show!
        </h3>
      )}
    </div>
  );
};

export default ConfirmBookings;
